
import { OrdersReplacementApiRemoteService } from '../../Services/api/orders-replacement/orders-replacement-service'
import { IOrdersReplacementListPayload, IOrdersReplacementListResponse, IPayloadOrderReplacement } from '../../Services/api/orders-replacement/orders-replacement.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ListOrdersReplacementUseCase
implements IFormUsecase<IOrdersReplacementListPayload, IOrdersReplacementListResponse> {
  constructor (private readonly OrdersReplacementApi: OrdersReplacementApiRemoteService) {}
    
  public async handle (
    data: IOrdersReplacementListPayload
  ): Promise<Result<IOrdersReplacementListResponse>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.OrdersReplacementApi.list(data)

      if (response.isFailure) {
        return response
      }
    
      const list = response.getValue()

      if(!list) return response
    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
